import { supabase } from './supabase';
import { professionalTemplates } from './templateDefinitions';

export async function seedResumeTemplates(): Promise<{ success: boolean; message: string }> {
  try {
    const templateRecords = professionalTemplates.map(template => ({
      name: template.name,
      description: template.description,
      category: template.category,
      layout_type: template.layout_type,
      template_data: template.template_data,
      color_schemes: template.color_schemes,
      font_settings: template.font_settings,
      features: template.features,
      ats_score: template.ats_score,
      popularity_score: template.popularity_score,
      industry_tags: template.industry_tags,
      is_premium: template.is_premium,
      is_active: template.is_active,
      preview_url: null,
    }));

    for (const template of templateRecords) {
      const { data: existing } = await supabase
        .from('resume_templates')
        .select('id')
        .eq('name', template.name)
        .maybeSingle();

      if (existing) {
        await supabase
          .from('resume_templates')
          .update(template)
          .eq('id', existing.id);
      } else {
        await supabase
          .from('resume_templates')
          .insert(template);
      }
    }

    return {
      success: true,
      message: `Successfully seeded ${templateRecords.length} resume templates`,
    };
  } catch (error) {
    console.error('Error seeding templates:', error);
    return {
      success: false,
      message: `Failed to seed templates: ${error}`,
    };
  }
}
